import { render, staticRenderFns } from "./travelAction.vue?vue&type=template&id=674c0ae7&scoped=true"
import script from "./travelAction.vue?vue&type=script&lang=js"
export * from "./travelAction.vue?vue&type=script&lang=js"
import style0 from "./travelAction.vue?vue&type=style&index=0&id=674c0ae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c0ae7",
  null
  
)

export default component.exports